import React from 'react';
import { motion } from 'framer-motion';
import { Github, ExternalLink, Code, Star, GitFork } from 'lucide-react';

const GitHubLeetCode = () => {
  return (
    <section className="github-leetcode-section">
      <div className="section-container">
        <motion.div
          className="platforms-container"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <motion.div
            className="platform-card github-card"
            whileHover={{ scale: 1.02, transition: { duration: 0.3 } }}
          >
            <div className="platform-header">
              <Github size={40} />
              <h3>GitHub</h3>
            </div>
            <p className="platform-description">
              Check out my repositories and open-source contributions. Building projects that solve real-world problems.
            </p>
            <div className="platform-stats">
              <div className="stat-item">
                <Code size={20} />
                <span>Multiple Projects</span>
              </div>
              <div className="stat-item">
                <Star size={20} />
                <span>Clean Code</span>
              </div>
            </div>
            <a
              href="https://github.com/PrazeCodes"
              target="_blank"
              rel="noopener noreferrer"
              className="platform-link"
            >
              Visit GitHub Profile
              <ExternalLink size={18} />
            </a>
          </motion.div>

          <motion.div
            className="platform-card leetcode-card"
            whileHover={{ scale: 1.02, transition: { duration: 0.3 } }}
          >
            <div className="platform-header">
              <Code size={40} />
              <h3>LeetCode</h3>
            </div>
            <p className="platform-description">
              Active problem solver on LeetCode, focusing on data structures, algorithms, and competitive programming.
            </p>
            <div className="platform-stats">
              <div className="stat-item">
                <Star size={20} />
                <span>Problem Solver</span>
              </div>
              <div className="stat-item">
                <GitFork size={20} />
                <span>DSA Expert</span>
              </div>
            </div>
            <a
              href="https://leetcode.com/u/Pranjal69/"
              target="_blank"
              rel="noopener noreferrer"
              className="platform-link"
            >
              Visit LeetCode Profile
              <ExternalLink size={18} />
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default GitHubLeetCode;